module.exports = __webpack_public_path__ + "files/062c84fe7737a2e0bae797434b2cf3a7.png";